/* eslint-disable import/order */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
/* eslint-disable operator-linebreak */

import { FaDownload, FaEnvelope } from 'react-icons/fa';
import { useEffect, useState } from 'react';

import CobrancaParcelaDTO from '../../dtos/CobrancaParcelaDTO';
import { Container } from './styles';
import DebitoDTO from '../../dtos/DebitoDTO';
import { MdOutlineAttachMoney } from 'react-icons/md';
import ParametroService from '../../services/ParametroService';
import Utils from '../../utils';
import moment from 'moment';
import { useAnuidade } from '../../hooks/anuidade';
import { useHistory } from 'react-router-dom';

export function Pagamento() {
  const history = useHistory();
  const {
    tipoPagamentoRecorrente,
    anuidade,
    pagamento,
    changePagamento,
    goBoletoEnviarPorEmail,
    goBoletoRealizarDownload,
    goCartaoRealizarPagamento,
  } = useAnuidade();

  const [isPagamentoBoletoLiberado, setIsPagamentoBoletoLiberado] =
    useState<boolean>(true);
  const [isPagamentoCartaoLiberado, setIsPagamentoCartaoLiberado] =
    useState<boolean>(true);

  useEffect(() => {
    if (!anuidade || !anuidade.pagamentoAnuidadeInscrito || !pagamento) {
      history.replace('/');
    }
  }, []);

  async function validatePermissaoPagamentos() {
    let isBoletoLiberado = false;
    let isCartaoLiberado = false;
    try {
      const bloqueioPagamentoBoleto = await ParametroService.getValorDinamico(
        'BLOQUEIO_PAGAMENTO_BOLETO_ANUIDADE',
      );
      isBoletoLiberado = bloqueioPagamentoBoleto.valor !== 'S';
    } catch (e) {
      isBoletoLiberado = false;
    }

    try {
      const bloqueioPagamentoCartao = await ParametroService.getValorDinamico(
        'BLOQUEIO_PAGAMENTO_CARTAO_ANUIDADE',
      );
      isCartaoLiberado = bloqueioPagamentoCartao.valor !== 'S';
    } catch (e) {
      isCartaoLiberado = false;
    }

    setIsPagamentoBoletoLiberado(isBoletoLiberado);
    setIsPagamentoCartaoLiberado(isCartaoLiberado);

    if (!isBoletoLiberado && !isCartaoLiberado) {
      changePagamento({
        ...pagamento.pagamento,
        formaPagamento: null,
        parcelaSelecionada: undefined,
      });
    }
    if (!isBoletoLiberado) {
      changePagamento({
        ...pagamento.pagamento,
        formaPagamento: 'C',
        parcelaSelecionada: undefined,
      });
    }
    if (!isCartaoLiberado) {
      changePagamento({
        ...pagamento.pagamento,
        formaPagamento: 'B',
        parcelaSelecionada: undefined,
      });
    }
  }

  useEffect(() => {
    validatePermissaoPagamentos();
  }, []);

  function onClickBoletoEnviarPorEmail() {
    goBoletoEnviarPorEmail();
  }

  function onClickBoletoRealizarDownload() {
    goBoletoRealizarDownload();
  }

  function onClickCartaoRealizarPagamento() {
    goCartaoRealizarPagamento();
  }

  function getTitleDebitos(): string {
    const {
      pagamento: { tipoSelecao },
    } = pagamento;
    if (tipoSelecao === 'T') {
      return 'Pagamento total selecionado';
    }
    if (tipoSelecao === 'V') {
      return 'Pagamento vencidos selecionado';
    }
    return '';
  }

  function getAnuidade(debito: DebitoDTO): string {
    if (debito.ano_fim_deb === debito.ano_inicio_deb) {
      return `${debito.ano_fim_deb}`;
    }
    return `${debito.ano_inicio_deb} / ${debito.ano_fim_deb}`;
  }
  function getDescricaoCota(debito: DebitoDTO): string {
    if (debito.total_cotas_deb === 0 && debito.cota_fim_deb === 0) {
      return '';
    }

    const totalCotas =
      debito.total_cotas_deb === 0 ? 'Int' : debito.total_cotas_deb;
    if (debito.cota_inicio_deb === debito.cota_fim_deb) {
      return `${debito.cota_fim_deb}/${totalCotas}`;
    }
    return `${debito.cota_inicio_deb}-${debito.cota_fim_deb}/${totalCotas}`;
  }

  function getDescricaoAvos(debito: DebitoDTO): string {
    if (debito.nro_avos_deb !== 0) {
      return `${debito.nro_avos_deb}`;
    }
    return '';
  }

  function getDataVencimento(debito: DebitoDTO): string {
    if (!debito.dta_venc_deb) {
      return '';
    }
    return moment(debito.dta_venc_deb, 'YYYYMMDD').format('DD/MM/YYYY');
  }

  function getValorAPagar(): number {
    const {
      cobranca: { parcelas, valorDesconto },
    } = pagamento;
    if (parcelas && parcelas.length > 0) {
      const primeiraParcela = parcelas[0];
      return primeiraParcela.valorPrimeiraParcela + valorDesconto;
    }
    return 0;
  }

  function getValorAPagarReal(): string {
    const valorPagar = getValorAPagar();
    return `${Utils.formatReal(valorPagar)}`;
  }

  function getFormataParcelaSelect(parcela: CobrancaParcelaDTO): string {
    if (parcela) {
      return `${parcela.qntParcelas}x de R$ ${Utils.formatReal(
        parcela.valorPrimeiraParcela,
      )}`;
    }
    return '';
  }

  function getObservacoesPagamentoAvista() {
    let observacoes = '';
    const {
      cobranca: { original },
    } = pagamento;
    if (original.MotivoAVista) {
      observacoes += `${original.MotivoAVista} `;
    }
    if (original.MsgDescontoAVista) {
      observacoes += `${original.MsgDescontoAVista} `;
    }

    return observacoes ? (
      <span>
        {observacoes}
        <br />
      </span>
    ) : null;
  }

  function getObservacoesPagamento() {
    let observacoes = '';
    const {
      pagamento: { parcelaSelecionada },
    } = pagamento;
    if (parcelaSelecionada) {
      const {
        cobranca: { original },
      } = pagamento;
      const { qntParcelas } = parcelaSelecionada;
      if (qntParcelas > 1) {
        if (original.TaxaJuros) {
          observacoes += `Taxa de juros(${original.TaxaJuros}) `;
        }
      }
    }
    return <span>{observacoes}</span>;
  }

  const { debitoResult } = anuidade;

  if (!pagamento || !pagamento.debitosAgrupados || !debitoResult) {
    return null;
  }

  const {
    cobranca,
    pagamento: { formaPagamento, parcelaSelecionada },
    emitirSeparado,
  } = pagamento;

  function isShowCartaoRecorrente() {
    if (
      isPagamentoCartaoLiberado &&
      tipoPagamentoRecorrente &&
      cobranca.parcelas.length > 1
    ) {
      return true;
    }
    return false;
  }

  let parcelas: CobrancaParcelaDTO[] = [];
  if (formaPagamento === 'B' || formaPagamento === 'R') {
    parcelas = cobranca.parcelas.filter((_, index) => index < 12);

    if (formaPagamento === 'R') {
      parcelas = parcelas.splice(1, parcelas.length - 1);
    }
  } else if (formaPagamento === 'C' && debitoResult.CodTipDeb === 23) {
    // Anuidades anteriores (código 23) no cartão: máximo de 12 parcelas
    parcelas = cobranca.parcelas.filter((_, index) => index < 12);
  } else {
    parcelas = [...cobranca.parcelas];
  }

  return (
    <Container>
      <div className="col-md-12">
        <div className="card mb-3">
          <div className="card-header text-white bg-danger">Débitos</div>
          <div className="card-body">
            <div className="title-debitos">
              <strong>{getTitleDebitos()}</strong>
            </div>
            <div className="content-table">
              <table className="table">
                <thead>
                  <th className="text-center">Anuidade</th>
                  <th className="text-center">Cota</th>
                  <th className="text-center">Avos</th>
                  <th className="text-center">Valor</th>
                  <th className="text-center">Multa</th>
                  <th className="text-center">Permanência</th>
                  <th className="text-center">Vencimento</th>
                  <th>Total</th>
                </thead>
                <tbody>
                  {pagamento.debitosAgrupados.map((debito) => (
                    <tr key={debito.id}>
                      <td className="text-center">{getAnuidade(debito)}</td>
                      <td className="text-center">
                        {getDescricaoCota(debito)}
                      </td>
                      <td className="text-center">
                        {getDescricaoAvos(debito)}
                      </td>
                      <td className="text-center">
                        {`R$ ${Utils.formatReal(debito.valor_anuid_deb)}`}
                      </td>
                      <td className="text-center">
                        {`R$ ${Utils.formatReal(debito.valor_multa_deb)}`}
                      </td>
                      <td className="text-center">
                        {`R$ ${Utils.formatReal(debito.valor_juros_deb)}`}
                      </td>
                      <td className="text-center">
                        {getDataVencimento(debito)}
                      </td>
                      <td>
                        {`R$ ${Utils.formatReal(debito.valor_total_deb)}`}
                      </td>
                    </tr>
                  ))}
                  {debitoResult &&
                  (debitoResult.ValorCashback || debitoResult.ValorPlano) ? (
                    <>
                      <tr>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                        <td className="info-right-table">
                          <span>
                            <strong>Valor total:</strong>
                          </span>
                        </td>
                        <td>
                          <span>
                            <strong>
                              {`R$ ${Utils.formatReal(
                                debitoResult.ValDebTotal,
                              )}`}
                            </strong>
                          </span>
                        </td>
                      </tr>
                      {debitoResult.ValorCashback ? (
                        <tr>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td className="info-right-table">
                            <span>
                              <strong>Desconto cashback:</strong>
                            </span>
                          </td>
                          <td>
                            <span>
                              <strong>
                                {`R$ ${Utils.formatReal(
                                  debitoResult.ValorCashback,
                                )}`}
                              </strong>
                            </span>
                          </td>
                        </tr>
                      ) : null}
                      {debitoResult.ValorPlano ? (
                        <tr>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td className="info-right-table">
                            <span>
                              <strong>Desconto plano de saúde:</strong>
                            </span>
                          </td>
                          <td>
                            <span>
                              <strong>
                                {`R$ ${Utils.formatReal(
                                  debitoResult.ValorPlano,
                                )}`}
                              </strong>
                            </span>
                          </td>
                        </tr>
                      ) : null}
                    </>
                    ) : null}
                  <tr>
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                    <td className="info-right-table">
                      <span>
                        <strong>Valor a pagar:</strong>
                      </span>
                    </td>
                    <td>
                      <span>
                        <strong>{`R$ ${getValorAPagarReal()}`}</strong>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              {getValorAPagar() === 0 ? (
                <div className="alert alert-info text-center" role="alert">
                  Desconto maior que o débito, nada a pagar.
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {getValorAPagar() > 0 ? (
          <div className="card mb-3">
            <div className="card-header text-white bg-danger">Pagamento</div>
            <div className="card-body">
              <form>
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label text-right">
                    Selecione a forma de pagamento:
                  </label>
                  <div className="col-sm-5">
                    <select
                      className="form-select"
                      value={formaPagamento || ''}
                      onChange={(e) => {
                        let formaPagamentoChange: 'B' | 'C' | 'R' = 'B';
                        switch (e.target.value) {
                          case 'B':
                            formaPagamentoChange = 'B';
                            break;
                          case 'C':
                            formaPagamentoChange = 'C';
                            break;
                          case 'R':
                            formaPagamentoChange = 'R';
                            break;
                          default:
                        }
                        changePagamento({
                          ...pagamento.pagamento,
                          formaPagamento: formaPagamentoChange,
                          parcelaSelecionada: undefined,
                        });
                      }}
                    >
                      {isPagamentoBoletoLiberado && (
                        <option value="B">Boleto</option>
                      )}
                      {isPagamentoCartaoLiberado && (
                        <option value="C">Cartão</option>
                      )}
                      {isShowCartaoRecorrente() && (
                        <option value="R">Cartão recorrente</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label text-right">
                    Parcelar em:
                  </label>
                  <div className="col-sm-3">
                    {emitirSeparado ? (
                      <p className="boletos-individuais">
                        <span>Boletos individuais</span>
                      </p>
                    ) : (
                      <select
                        className="form-select"
                        value={parcelaSelecionada ? parcelaSelecionada.id : ''}
                        disabled={!isPagamentoBoletoLiberado && !isPagamentoCartaoLiberado}
                        onChange={(e) => {
                          const parcelaSelecionadaChange = parcelas.find(
                            (parcela) => {
                              const result = parcela.id === e.target.value;
                              return result;
                            },
                          );
                          changePagamento({
                            ...pagamento.pagamento,
                            parcelaSelecionada: parcelaSelecionadaChange,
                          });
                        }}
                      >
                        <option value="">Selecione...</option>
                        {parcelas.map((parcela) => (
                          <option value={parcela.id}>
                            {getFormataParcelaSelect(parcela)}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label text-right">
                    Observações:
                  </label>
                  <div className="col-sm-8">
                    <p className="info-observacoes">
                      {getObservacoesPagamentoAvista()}
                      {getObservacoesPagamento()}
                    </p>
                  </div>
                </div>
              </form>

              <div className="row base-resume-pagamento-boleto-cartao">
                <div className="col-md-6">
                  <p>
                    {'Total: '}
                    <strong>
                      {`R$ ${Utils.formatReal(
                        pagamento.pagamento.parcelaSelecionada
                          ? pagamento.pagamento.parcelaSelecionada.total
                          : 0,
                      )}`}
                    </strong>
                  </p>
                </div>
                <div className="col-md-6">
                  {pagamento.pagamento.formaPagamento === 'B' ? (
                    <div className="row">
                      <div className="col-md-6">
                        <button
                          type="button"
                          disabled={
                            !emitirSeparado &&
                            !pagamento.pagamento.parcelaSelecionada
                          }
                          className="btn btn-danger btn-pagamento-boleto"
                          onClick={onClickBoletoEnviarPorEmail}
                        >
                          <FaEnvelope />
                          Enviar por email
                        </button>
                      </div>
                      <div className="col-md-6">
                        <button
                          type="button"
                          disabled={
                            !emitirSeparado &&
                            !pagamento.pagamento.parcelaSelecionada
                          }
                          className="btn btn-danger btn-pagamento-boleto"
                          onClick={onClickBoletoRealizarDownload}
                        >
                          <FaDownload />
                          Fazer download
                        </button>
                      </div>
                    </div>
                  ) : null}
                  {pagamento.pagamento.formaPagamento === 'C' ||
                  pagamento.pagamento.formaPagamento === 'R' ? (
                    <div className="col-md-12">
                      <button
                        type="button"
                        disabled={!pagamento.pagamento.parcelaSelecionada}
                        className="btn btn-danger btn-pagamento-cartao"
                        onClick={onClickCartaoRealizarPagamento}
                      >
                        <MdOutlineAttachMoney />
                        Realizar pagamento
                      </button>
                    </div>
                    ) : null}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </Container>
  );
}
